import { Sheet, SheetContent, SheetHeader, SheetTitle, SheetTrigger, SheetDescription } from "@/components/ui/sheet";
import { Tabs, TabsList, TabsTrigger, TabsContent } from "@/components/ui/tabs";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { Info } from "lucide-react";

export const ExplainDrawer = ({ trigger, title, description, formula, inputs = [], sources = [], rawRows = [], rawCols = [], testid = "explain" }) => (
  <Sheet>
    <SheetTrigger asChild>{trigger}</SheetTrigger>
    <SheetContent side="right" className="w-full sm:max-w-lg overflow-y-auto thin-scroll" data-testid={`${testid}-drawer`}>
      <SheetHeader>
        <SheetTitle className="font-display text-xl flex items-center gap-2"><Info className="h-4 w-4 text-gold" />{title}</SheetTitle>
        {description && <SheetDescription>{description}</SheetDescription>}
      </SheetHeader>
      <Tabs defaultValue="formula" className="mt-4">
        <TabsList className="grid w-full grid-cols-3">
          <TabsTrigger value="formula">Formula</TabsTrigger>
          <TabsTrigger value="sources">Sources</TabsTrigger>
          <TabsTrigger value="raw">Raw events</TabsTrigger>
        </TabsList>
        <TabsContent value="formula" className="space-y-4 pt-4">
          <div className="rounded-lg border bg-muted/40 p-4">
            <p className="text-xs uppercase tracking-wide text-muted-foreground mb-1">Definition</p>
            <p className="font-mono text-sm">{formula}</p>
          </div>
          {inputs.length > 0 && (
            <div>
              <p className="text-xs uppercase tracking-wide text-muted-foreground mb-2">Inputs</p>
              <ul className="space-y-1 text-sm">{inputs.map((i, k) => <li key={k} className="flex justify-between border-b border-dashed py-1"><span className="text-muted-foreground">{i.label}</span><span className="mono">{i.value}</span></li>)}</ul>
            </div>
          )}
        </TabsContent>
        <TabsContent value="sources" className="pt-4">
          <p className="text-xs uppercase tracking-wide text-muted-foreground mb-2">Source systems (connectors)</p>
          <ul className="space-y-2">{sources.map((s, k) => <li key={k} className="flex items-center gap-2 rounded-md border p-2 text-sm"><span className="mono text-xs text-gold">{s.id}</span>{s.name}</li>)}</ul>
          <p className="mt-4 text-xs text-muted-foreground">Last computed just now · pseudonymised in analytics.</p>
        </TabsContent>
        <TabsContent value="raw" className="pt-4">
          {rawRows.length === 0 ? <p className="text-sm text-muted-foreground">No raw events in scope.</p> : (
            <div className="rounded-lg border overflow-hidden">
              <Table><TableHeader><TableRow>{rawCols.map((c) => <TableHead key={c} className="text-xs">{c}</TableHead>)}</TableRow></TableHeader>
                <TableBody>{rawRows.slice(0, 8).map((r, k) => <TableRow key={k}>{r.map((c, i) => <TableCell key={i} className="text-xs mono py-1.5">{c}</TableCell>)}</TableRow>)}</TableBody>
              </Table>
            </div>
          )}
        </TabsContent>
      </Tabs>
    </SheetContent>
  </Sheet>
);
